import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/agreements/new/loading';

export const Route = createFileRoute('/_private/agreements/new')({
  pendingComponent: Loading,
});
